import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const a1 = Math.floor(Math.random() * 10) - 5; // a1 ∈ [-5,4]
  let r;
  do {
    r = Math.floor(Math.random() * 11) - 5;      // r ∈ [-5,5] \ {0}
  } while (r === 0);
  const n = Math.floor(Math.random() * 8) + 3;   // n ∈ [3,10]

  const Sn = (n / 2) * (2 * a1 + (n - 1) * r);

  return {
    type: "FindSumTask",
    data: { a1, r, n, Sn }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { a1, r, n } = data;

  return (
    <>
      <p>
        Dany jest ciąg arytmetyczny o pierwszym wyrazie{" "}
        <InlineMath math={`a_1 = ${a1}`} /> i różnicy{" "}
        <InlineMath math={`r = ${r}`} />.
      </p>
      <p>
        Oblicz sumę pierwszych <InlineMath math={`${n}`} /> wyrazów ciągu.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseFloat(userAnswer.raw);
  if (isNaN(given)) return false;

  userAnswer.n = data.n;

  return Math.abs(given - data.Sn) < 0.01;
}

export function renderAnswer({ data }) {
  return (
    <InlineMath math={`S_${data.n} = ${data.Sn}`} />
  );
}

export function renderExplanation({ data }) {
  const { a1, r, n, Sn } = data;

  const twoA1 = 2 * a1;
  const nMinus1 = n - 1;
  const rPart = nMinus1 * r;
  const middle = twoA1 + rPart;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Wzór na sumę <InlineMath math="n" /> wyrazów ciągu arytmetycznego:
      </p>
      <BlockMath math={`S_n = \\frac{n}{2} \\big( 2a_1 + (n-1)r \\big)`} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane i obliczamy:
      </p>

      <BlockMath
        math={`S_${n} = \\frac{${n}}{2} \\big( 2 \\cdot ${a1} + (${n}-1) \\cdot ${r} \\big)`}
      />
      <BlockMath
        math={`S_${n} = \\frac{${n}}{2} \\big( ${twoA1} + ${nMinus1} \\cdot ${r} \\big)`}
      />
      <BlockMath
        math={`S_${n} = \\frac{${n}}{2} \\big( ${twoA1} + ${rPart} \\big)`}
      />
      <BlockMath
        math={`S_${n} = \\frac{${n}}{2} \\cdot ${middle} = ${Sn}`}
      />
    </div>
  );
}


export function renderUserAnswer(userAnswer, task) {
  const n = userAnswer?.n ?? task?.data?.n ?? '?';

  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return (
    <InlineMath math={`S_{${n}} = ${userAnswer.raw}`} />
  );
}

